import React, { useState, useEffect, createContext } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types'
import { gridFilterTypes, scheduleAlertType, performanceAlertType } from '../components/Modules/TeamAlerts/component/utils/constants';
import AlertType from '../constants/alertType';

export const TeamAlertsContext = createContext({
    gridFilterOptions: {
        [gridFilterTypes.AlertType]: null,
        [gridFilterTypes.Agent]: null,
        [gridFilterTypes.TeamLead]: null
    },
    setGridFilterOptions: () => {},
    searchOptions: {
        clientId: null,
        projectId: null,
        programId: null,
        siteId: null,
        agentOracleId: null,
        agentName: null,
        supervisorOracleId: null
    },
    setSearchOptions: () => {}
});

export const TeamAlertsContextProvider = ({ children }) => {
    const selectedAlertType = useSelector((state) => state.Alerts.selectedAlert);
    const [searchOptions, setSearchOptions] = useState({
        clientId: null,
        projectId: null,
        programId: null,
        siteId: null,
        agentOracleId: null,
        agentName: null,
        supervisorOracleId: null
    });

    const alert = {
        title: gridFilterTypes.AlertType,
        options: [],
        ascendingSortOrder: null,
        isOptionActive: false
    }

    const agent = {
        title: gridFilterTypes.Agent,
        options: [],
        ascendingSortOrder: null,
        isOptionActive: false
    }

    const teamLead = {
        title: gridFilterTypes.TeamLead,
        options: [],
        ascendingSortOrder: null,
        isOptionActive: false
    }

    const [gridFilterOptions, setGridFilterOptions] = useState({ [gridFilterTypes.AlertType]: alert, [gridFilterTypes.Agent]: agent, [gridFilterTypes.TeamLead]: teamLead });

    useEffect(() => {
        if (selectedAlertType) {
            let alertFilterOptions = alert;
            if (selectedAlertType === AlertType.schedule) {
                const optionsSchedule = scheduleAlertType.map(alertTypeOption => ({ title: alertTypeOption, isActive: false }));

                alertFilterOptions = {
                title: gridFilterTypes.AlertType,
                options: optionsSchedule,
                ascendingSortOrder: null,
                isOptionActive: false
                }
            }
            else {
                const optionsPerformance = performanceAlertType.map(alertTypeOption => ({ title: alertTypeOption, isActive: false }));
                alertFilterOptions = {
                    title: gridFilterTypes.AlertType,
                    options: optionsPerformance,
                    ascendingSortOrder: null,
                    isOptionActive: false
                }
            }

            setGridFilterOptions({ [gridFilterTypes.AlertType]: alertFilterOptions, [gridFilterTypes.Agent]: agent, [gridFilterTypes.TeamLead]: teamLead });
        }
    }, [selectedAlertType]);

    return <TeamAlertsContext.Provider value={{gridFilterOptions, setGridFilterOptions, searchOptions, setSearchOptions}}>{children}</TeamAlertsContext.Provider>
}

TeamAlertsContextProvider.propTypes = {
    children: PropTypes.node.isRequired
}
